import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { FeeTempletMappingDialogBoxComponent } from '../fee-templet-mapping-dialog-box/fee-templet-mapping-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-fee-templet-mapping',
  templateUrl: './fee-templet-mapping.component.html',
  styleUrls: ['./fee-templet-mapping.component.scss']
})
export class FeeTempletMappingComponent implements OnInit {
  feeMappingForm: FormGroup;
  FeetempDataSearchForm:FormGroup;
  templetMapList: any;
  APIService: string;
pageSize = 10;
pageSizeOptions: number[] = [5, 10, 20];
currentPage = 1;
totalItems = 0;
userPermission
UserCollege
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService) {this.APIService = environment.serviceUrl; }
   dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    window.scroll(0, 0);
    this.FeetempDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getTempletMapData();
  }
  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getTempletMapData();
   this.keypress();
  }

  getTempletMapData() {
   if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege
    this.umsService.getFeeTempletMapping(payload).subscribe(res => {
      this.spinner.hide();
      this.templetMapList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      
    });
  }
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      let payload = {}
      payload['SearchString'] = this.FeetempDataSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchFeeTempMapping(payload).subscribe(
        (res) => {
          
          // this.totalItems = res.data[0].TotalRecords;
          if(res.status != true){
            this.templetMapList = [];
            this.totalItems = 0;
          }
          else{
            this.templetMapList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
        }, (ERROR: HttpErrorResponse) => {
          this.templetMapList = [];
        });
    },1000)
    
  }
    addnewrecord() { 
      const dialogRef = this.dialog.open(FeeTempletMappingDialogBoxComponent, {
        width: '75vh',
        data: {key : "New"},
        disableClose: true  
      });  
      dialogRef.afterClosed().subscribe(result => { 
        this.getTempletMapData(); 
        this.FeetempDataSearchForm.controls['SearchString'].setValue('');
      });
    }
    editData(k){
      const dialogRef = this.dialog.open(FeeTempletMappingDialogBoxComponent, {
        width: '90vh',
        data: { selected: k, key : "Edit"},
        disableClose: true 
      });
      dialogRef.afterClosed().subscribe(result => {
          this.getTempletMapData(); 
        this.FeetempDataSearchForm.controls['SearchString'].setValue('');
      });
    }
    deleteData(k){
      const dialogRef = this.dialog.open(FeeTempletMappingDialogBoxComponent, {
        width: '90vh',
        data: { selected: k, key : "Delete"},
        disableClose: true 
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getTempletMapData(); 
        this.FeetempDataSearchForm.controls['SearchString'].setValue('');
      });
    }
download(event: Event) {
  event.preventDefault();

  const payload: any = {
    PageSize: 100000,        // fetch all records
    PageNumber: 1,
    SearchString: this.FeetempDataSearchForm.value['SearchString'] || ''
  };

  // apply college filter if user is college user
  if (this.userPermission[0].CgUi === 'C') {
    payload['CgCode'] = this.userPermission[0].CgId;
  }

  this.spinner.show();

  this.umsService.searchFeeTempMapping(payload).subscribe(
    (res) => {
      this.spinner.hide();

      if (!res.status || !res.data || res.data.length === 0) {
        return;
      }

      const extractedData = res.data.map(element => {
        return {
          'Session': element.SnName,
          'Template Code': element.FeeTemplate,
          'Course Name': element.CoName,
          'College Name': element.CgName,
          'Exam': element.EmName,
          'Fee Type': element.CdDesc,
          'Total Amount': element.TotalFeeAmount
        };
      });

      const csvContent = this.convertArrayToCSV(extractedData);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Fee_Template_Mapping_Report.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    },
    () => {
      this.spinner.hide();
    }
  );
}

 convertArrayToCSV(array: any[]) {
  const header = Object.keys(array[0]).join(',');
  const rows = array.map(obj =>
    Object.values(obj)
      .map(value => `"${value ?? ''}"`)
      .join(',')
  );
  return [header, ...rows].join('\n');
}

}